// Display names for job kinds. Pure formatting: the API decides what runs, this decides what it is
// called on screen. A kind this build has never heard of (one another workstream registered) still
// reads as words rather than a slug.
const KIND_LABELS: Record<string, string> = {
  'voice-build': 'Read your mailbox',
  'voice-scan': 'Sort your mail',
  'voice-measure': 'Measure your drafts',
  'deal-scan': 'Find leads and opportunities',
  'mail-pull': 'Pull messages',
  'contact-watch': 'Re-weigh your contacts',
  'methodology-ingest': 'Read the methodology',
  'transcript-import': 'Import transcripts',
  'transcript-extract': 'Read a transcript',
  'calendar-sync': 'Sync your calendar',
  'notes-sync': 'Read your OneNote',
  'lead-research': 'Research a company',
  'weekly-write': 'Write the weekly update',
  'photo-enrich': 'Find profile pictures',
  'threat-watch': 'Watch for threats',
  'contact-onboard': 'Stage a contact import',
  'priority-contacts': 'Reconcile your priority contacts',
  'self-improve': 'Learn from your corrections',
  'mail-sync': 'Check for new mail',
}

export function jobKindLabel(kind: string): string {
  return KIND_LABELS[kind] ?? kind.replace(/-/g, ' ').replace(/^./, (c) => c.toUpperCase())
}

/** The scheduler stamps the run that started a job onto the kind's own request. Null when a person pressed it. */
export function schedulerRunId(requestJson: string | null | undefined): string | null {
  if (!requestJson || !requestJson.includes('scheduler')) return null
  try {
    const parsed: unknown = JSON.parse(requestJson)
    if (typeof parsed !== 'object' || parsed === null) return null
    const value = (parsed as Record<string, unknown>).scheduler
    return typeof value === 'string' && value.length > 0 ? value : null
  } catch {
    return null
  }
}
